module.exports = __webpack_public_path__ + "img/background.f8c2458f.jpg";